const PUBLIC_NEIGHBORHOOD_DISPLAY_NAMES: Readonly<Record<string, string>> = {
  'The Greens (Southeast)': 'Fairwood Greens (Southeast)',
  Carriagewood: 'Carriage Wood',
};

export function publicNeighborhoodDisplayName(neighborhood: string): string {
  return PUBLIC_NEIGHBORHOOD_DISPLAY_NAMES[neighborhood] ?? neighborhood;
}
